/* src/app/components/controls/sem-tags-input/sem-tags-input.component.css */
:host {
  display: block;
}
:host ::ng-deep .mat-mdc-form-field {
  display: block;
}
:host ::ng-deep .tags-readonly .mat-mdc-text-field-wrapper,
:host ::ng-deep .tags-readonly .mdc-text-field,
:host ::ng-deep .tags-readonly .mdc-text-field--filled {
  background-color: #f8fafc !important;
  cursor: default !important;
}
.tag-input {
  border: none;
  outline: none;
  background: transparent;
  box-shadow: none;
  flex: 1 1 80px;
  min-width: 80px;
  padding: 4px 2px;
  font: inherit;
  color: inherit;
}
.tag-input::placeholder {
  color: #9aa5b1;
  opacity: 1;
}
:host ::ng-deep .mat-mdc-text-field-wrapper {
  height: auto;
  min-height: 36px;
}
:host ::ng-deep .mat-mdc-chip-grid {
  padding: 2px 0;
}
/*# sourceMappingURL=sem-tags-input.component.css.map */
